import { createSelector } from '@ngrx/store';
import { authStateFeatureSelector } from '../state';

const selectScimState = createSelector(authStateFeatureSelector, (authState) => authState.scim);

const selectAll = createSelector(selectScimState, (scimState) =>
  scimState.apiKeys.ids.map((id) => scimState.apiKeys.entities[id])
);

export const ScimSelectors = {
  selectAll,
  selectById: (keyId: string) => createSelector(selectScimState, (scimState) => scimState.apiKeys.entities[keyId] || null),
  isLoading: createSelector(selectScimState, (scimState) => scimState.isLoading),
};
